export default "__VITE_ASSET__E1AGxM5W__"